/**
 * Permissões do produto crialume que só existem no front, por papel.
 *
 * As demais vêm do backend, na claim `permissions` do token. O backend confere de novo
 * em toda rota; aqui é só para mostrar ou esconder. Fica no shell (composition root),
 * não no core: o core só sabe que "papéis viram permissões".
 */
export const ROLE_PERMISSIONS: Record<string, readonly string[]> = {
  /** Operador da plataforma: cria moldes, administra a comunidade e vê os números e contatos do negócio. */
  platform: [
    "home.view",
    "studio.author",
    "molds.customize",
    "accounts.manage",
    "insights.view",
    "leads.view",
  ],
  /** Membro com conta global: acessa os braços liberados para a conta. */
  member: ["home.view", "molds.customize"],
};

/** Claim do token com as permissões vindas do backend. */
export const PERMISSIONS_CLAIM = "permissions";

/** Modo mock (sem backend): o papel simula o que o backend mandaria. */
export const MOCK_ROLE_PERMISSIONS: Record<string, readonly string[]> = {
  platform: ROLE_PERMISSIONS["platform"]!,
  member: ROLE_PERMISSIONS["member"]!,
};
